// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/receipt.js';

import { paths } from '../generated/receipt';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('receipt', Original, paths);
